<p-dropdown [options]="grupos" [(ngModel)]="value" optionLabel="nome"
    [optionValue]="returnType === 'id' ? 'id' : undefined" [filter]="true" [filterBy]="undefined" [showClear]="true"
    (onFilter)="onFilter($event)" (onChange)="onSelect($event.value)" (onBlur)="onTouched()" [loading]="loading"
    scrollHeight="280px" appendTo="body" panelStyleClass="dropdown-panel-above-modal" styleClass="w-full" [panelStyle]="{'min-width': '100%', 'width': 'max-content', 'max-width': '600px'}"
    [placeholder]="placeholder || ('relatorio-itens-vendidos.placeholders.selecione' | translate)">

    <ng-template pTemplate="header">
        <div class="flex font-semibold px-2 py-1 ml-2 border-bottom-1 surface-border text-sm">
            <div class="mr-2" style="flex: 0 0 56px; min-width: 0;">{{ 'relatorio-itens-vendidos.table_headers.codigo' | translate }}</div>
            <div style="flex: 1; min-width: 0;">{{ 'relatorio-itens-vendidos.table_headers.nome' | translate }}</div>
        </div>
    </ng-template>
    <ng-template let-grupo pTemplate="item">
        <div class="flex text-sm align-items-center">
            <div class="mr-2" style="flex: 0 0 56px; min-width: 0;">{{ grupo.codigoGrupo }}</div>
            <div style="flex: 1; min-width: 0;">{{ grupo.nome }}</div>
        </div>
    </ng-template>

    <ng-template pTemplate="empty">
        <div class="p-2 text-center text-500">{{ 'relatorio-itens-vendidos.spans.nenhum_produto_encontrado' |
            translate
            }}</div>
    </ng-template>

    <ng-template pTemplate="footer">
        <div *ngIf="showAddButton" class="grupo-add-item" role="button" tabindex="0" (mousedown)="onAddNew($event)">
            <div class="grupo-add-icon">
                <i class="pi pi-plus"></i>
            </div>
            <span class="grupo-add-label">{{ textoAgregarCategoria }}</span>
        </div>
    </ng-template>
</p-dropdown>

<!-- Dialog de nova categoria -->
<app-grupo-adicionar-dialog
    [(visible)]="dialogVisible"
    (grupoCriado)="onGrupoCriado($event)">
</app-grupo-adicionar-dialog>